<template>
  <a-modal
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :visible="visible"
    title="数据权限配置"
    @ok="submitForm"
    @cancel="handleCancel"
    :width="width"
  >
    <a-form
      :form="form"
      :layout="formLayout"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item label="审批额度(元)">
        <a-input
          v-decorator="[
            'min',
            {
              initialValue: tableRow.min,
              rules: [{ required: true, message: '请输入审批额度!' }],
            },
          ]"
        />
      </a-form-item>
      <a-form-item>-</a-form-item>
      <a-form-item>
        <a-input
          v-decorator="[
            'max',
            {
              initialValue: tableRow.max,
              rules: [{ required: true, message: '请输入审批额度!' }],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="业务类型">
        <a-tree
          v-decorator="['ids']"
          :autoExpandParent="true"
          checkable
          :tree-data="treeData"
          :defaultExpandAll="true"
          v-model="checkedKeys"
          :defaultCheckedKeys="checkedKeys"
          :replace-fields="replaceFields"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import {
  getPermissionLevels,
  getJsonList,
  queryConfig,
  setConfig,
} from '../api'
import cloneDeep from 'lodash/cloneDeep'
export default {
  data() {
    return {
      width: 620,
      visible: false,
      confirmLoading: false,
      formLayout: 'inline',
      labelCol: {
        xs: { span: 10 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 12 },
      },
      selectList: [],
      checkedKeys: [],
      treeData: [],
      replaceFields: {
        children: 'children',
        title: 'name',
        key: 'id',
      },
      username: {
        value: 'benjycui',
      },
      tableRow: {},
      id: '',
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'createForm' })
  },
  mounted() {
    this._getPermissionLevels()
    this._getJsonList()
  },
  methods: {
    // 权限配置Tree树-请求数据
    _getJsonList() {
      getJsonList().then(({ data }) => {
        this.treeData = data
      })
    },
    // 权限级别-请求数据
    _getPermissionLevels() {
      getPermissionLevels().then(({ data }) => {
        this.selectList = data
      })
    },
    // 新增
    add() {
      this.form.resetFields()
      this.tableRow = {}
      this.checkedKeys = []
      this.id = ''
    },
    //配置
    async edit(tableRow) {
      await this.add()
      this.visible = true
      this.tableRow = tableRow
      queryConfig(tableRow.id).then(({ code, data }) => {
        if (code === '0000') {
          this.tableRow = data
          this.checkedKeys = cloneDeep(data.ids)
          this.sysUserId = data.sysUserId
          this.id = data.id
        }
      })
    },
    // 取消
    handleCancel() {
      this.visible = false
    },
    // 提交数据
    submitForm(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let data = Object.assign({}, values)
          data.ids = this.checkedKeys
          data.id = this.id
          data.sysUserId = this.sysUserId
          //this.$emit('create', data)
          setConfig(data).then(({ message }) => {
            if (!err) {
              this.$notification.success({
                message: '提示',
                description: message,
              })
              this.visible = false
              this.$emit('getTableData')
            }
          })
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-form-inline .ant-row:nth-child(1) {
  width: 50%;
}
/deep/ .ant-form-inline .ant-row:nth-child(1) .ant-form-item-control-wrapper,
/deep/ .ant-form-inline .ant-row:nth-child(3) .ant-form-item-control-wrapper {
  width: 140px;
}
/deep/ .ant-form-inline .ant-row:nth-child(3) {
  width: 38%;
}
/deep/ .ant-form-inline .ant-row:nth-child(2) {
  width: 20px;
}
</style>
